/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React, { useState } from "react";
// import Button from "../../../../../components/common/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import styles from "./styles";
import Typography from "../../../../../components/common/new/Typography/Typography";
import { SET_SELECTED_FRIEND } from "../../../../../redux/actionTypes/dashboard";
import { ROUTES } from "../../../../../utils/constants";
import { PERMISSIONS } from "../../../../../contants";
import NewEdit from "../../../../../assets/svg/NewEdit";
import Loader from "../../../../../components/common/Loader/Loader";
import { getInitials } from "../../../../member/memberDetails/utlis";

// const PROFILE_IMAGE =
//   "https://s3.ap-south-1.amazonaws.com/bharatsokagakkai.uat.public/test-data/profile.webp";

function ProfileRow({ lebel, value, color }) {
  return (
    <Box style={styles.rowContainer} py="8px">
      <Box style={styles.rowKey}>
        <Typography weight={600} fontSize="14px" color={color || "#393939"}>
          {lebel}
        </Typography>
      </Box>
      <Box style={styles.rowValue}>
        <Typography fontSize="16px" color={color || "#393939"}>
          {value || "NA"}
        </Typography>
      </Box>
    </Box>
  );
}

export default function FriendDetailCard({ friendInfo, hasPermission }) {
  const {
    friendId,
    fullName,
    mobileNumber,
    emailId,
    nationalityName,
    addressLine1,
    cityName,
    pincode,
    stateName,
    introducerName,
    introducerEmail,
    introducerMobileNumber,
    dateOfBirth,
    professionName,
    createdAt,
    divisionName,
    subDivisionName,
    // blockName,
    // firstMeeting,
    genderName,
    universityName,
    collegeName,
    profilePhotoUrl,
  } = friendInfo;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const onEditClick = () => {
    setIsLoading(true);
    setTimeout(() => {
      dispatch({ type: SET_SELECTED_FRIEND, payload: friendInfo });
      navigate(`${ROUTES.FRIEND_EDIT_PROFILE.path}/${friendId}`);
      setIsLoading(false);
    }, 2000);
  };

  return (
    // <>
    //   <Box style={styles.cardContainer} pt="10px">
    //     <Box sx={styles.imgContainer}>
    //       <img
    //         src={PROFILE_IMAGE}
    //         style={styles.profileImage}
    //         alt="Trulli"
    //         width="150"
    //         height="150"
    //       />
    //     </Box>
    //     <Box textAlign="center" mt={3}>
    //       <Typography weight={500} variant="body" color="#8C8C8C">
    //         {fullName}
    //       </Typography>
    //     </Box>

    //     {/* <ProfileRow
    //       lebel="Date of Joining"
    //       value={
    //         dateOfJoining !== null
    //           ? moment(dateOfJoining).format("DD/MM/YYYY")
    //           : "NA"
    //       }
    //     /> */}
    //     {/* <ProfileRow
    //       lebel="Date of First Meeting"
    //       value={
    //         firstMeeting !== null
    //           ? moment(firstMeeting).format("DD/MM/YYYY")
    //           : "NA"
    //       }
    //     /> */}
    //     <ProfileRow lebel="Division" value={divisionName} />
    //     <ProfileRow lebel="Sub Division" value={subDivisionName} />
    //     <Divider style={styles.divider} />
    //     <ProfileRow
    //       lebel="Date of Birth"
    //       value={
    //         dateOfBirth !== null
    //           ? moment(dateOfBirth).format("DD/MM/YYYY")
    //           : "NA"
    //       }
    //     />

    //     <ProfileRow lebel="Phone No" value={mobileNumber} />

    //     <ProfileRow lebel="Email" value={emailId} />
    //     <ProfileRow lebel="Profession" value={professionName} />

    //     <ProfileRow lebel="Nationality/Country" value={nationalityName} />
    //     <ProfileRow lebel="Gender" value={genderName} />
    //     <ProfileRow
    //       lebel="Date of Joining"
    //       value={
    //         createdAt !== null ? moment(createdAt).format("DD/MM/YYYY") : "NA"
    //       }
    //     />
    //     <ProfileRow
    //       lebel="Date of First Meeting"
    //       value={
    //         firstMeeting !== null
    //           ? moment(firstMeeting).format("DD/MM/YYYY")
    //           : "NA"
    //       }
    //     />
    //     <Divider style={styles.divider} />

    //     <ProfileRow lebel="Address" value={addressLine1} />

    //     <ProfileRow lebel="State" value={stateName} />

    //     <ProfileRow lebel="City" value={cityName} />

    //     <ProfileRow lebel="Pin Code" value={pincode} />
    //     <Box style={styles.button}>
    //       {hasPermission(PERMISSIONS.UPDATE_FRIEND) && (
    //         // hasPermission(PERMISSIONS.UPDATE_MEMBER_DOB) ||
    //         // hasPermission(PERMISSIONS.UPDATE_MEMBER_NAME) ?
    //         <Button
    //           style={styles.btnStyle}
    //           label="Edit"
    //           variant="outlined"
    //           onClick={onEditClick}
    //         />
    //       )}
    //     </Box>
    //   </Box>

    //   <Box style={styles.cardContainer} pt="10px" mt="30px">
    //     <ProfileRow lebel="Introducer's Name" value={introducerName} />
    //     <ProfileRow
    //       lebel="Introducer's Number"
    //       value={introducerMobileNumber}
    //     />
    //     <ProfileRow lebel="Introducer's Email" value={introducerEmail} />

    //     {/* <Box style={styles.button}>
    //       <Button
    //         style={styles.btnStyle}
    //         label="Edit"
    //         variant="outlined"
    //         // onClick={onEditClick}
    //       />
    //     </Box> */}
    //   </Box>
    //   {/* <Box style={styles.cardContainer} pt="10px" mt="30px">
    //     <ProfileRow lebel="Division" value={divisionName} />
    //     <ProfileRow lebel="Sub Division" value={subDivisionName} />
    //     <ProfileRow lebel="Block" value={blockName} /> */}
    //   {/* <Box style={styles.button}>
    //       <Button
    //         style={styles.btnStyle}
    //         label="Edit"
    //         variant="outlined"
    //         onClick={onEditClick}
    //       />
    //     </Box> */}
    //   {/* </Box> */}
    // </>

    <Box style={{ display: "flex", flexDirection: "row", flexGrow: 1 }}>
      <Box
        style={{
          ...styles.cardContainer,
          background:
            "linear-gradient(180deg, #B6E5FF 0%, rgba(255, 255, 255, 0.21) 100%)",
        }}
        mt="10px"
        mb="10px"
      >
        <Box>
          <Box sx={styles.imgContainer}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              {profilePhotoUrl ? (
                <img
                  src={profilePhotoUrl}
                  alt=""
                  style={styles.profileImage}
                  width="120"
                  height="120"
                />
              ) : (
                <div style={styles.imageView} width="150" height="150">
                  {getInitials(fullName)}
                </div>
              )}
            </div>
          </Box>
          <Box textAlign="center" mt={3}>
            <Typography
              weight={600}
              variant="body"
              fontSize="22px"
              color="#0E78B6"
            >
              {fullName}
            </Typography>
          </Box>
          <ProfileRow
            color="#143786"
            lebel="Date of Joining"
            value={createdAt ? moment(createdAt).format("DD-MM-YYYY") : "NA"}
          />
          <ProfileRow
            color="#143786"
            lebel="Date of Birth"
            value={dateOfBirth ? moment(dateOfBirth).format("MM-YYYY") : "NA"}
          />
          <ProfileRow color="#143786" lebel="Phone No" value={mobileNumber} />
          <ProfileRow color="#143786" lebel="Email" value={emailId} />
          <ProfileRow
            color="#143786"
            lebel="Nationality/Country"
            value={nationalityName}
          />
          <ProfileRow lebel="Gender" value={genderName} color="#143786" />
        </Box>
      </Box>

      <Box
        style={{
          ...styles.cardContainer,
          background:
            "linear-gradient(180deg, rgba(236, 192, 252, 0.28) 0%, rgba(255, 255, 255, 0.51) 68.23%)",
        }}
        mt="10px"
        mb="10px"
      >
        <Box>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography style={styles.cardHeading}>Address Details</Typography>
            {
              // hasPermission(PERMISSIONS.UPDATE_MEMBER) ||
              // hasPermission(PERMISSIONS.UPDATE_MEMBER_DOB) ||
              hasPermission(PERMISSIONS.UPDATE_FRIEND) ? (
                <Box style={{ cursor: "pointer" }}>
                  <NewEdit onClick={onEditClick} />
                </Box>
              ) : null
            }
          </Box>

          <ProfileRow color="#393939" lebel="Address" value={addressLine1} />
          <ProfileRow lebel="State" value={stateName} />
          <ProfileRow lebel="City" value={cityName} />
          <ProfileRow lebel="Pincode" value={pincode} />

          <div style={{ paddingTop: "20px" }} />

          <Typography style={styles.cardHeading}>
            Professional Details
          </Typography>
          <ProfileRow lebel="University" value={universityName} />
          <ProfileRow lebel="College" value={collegeName} />
          <ProfileRow lebel="Profession" value={professionName} />
          {/* <ProfileRow
            lebel="Date of First Meeting"
            value={
              firstMeeting !== null
                ? moment(firstMeeting).format("DD-MM-YYYY")
                : "NA"
            }
          /> */}
        </Box>
      </Box>

      <Box
        style={{
          ...styles.cardContainer,
          background:
            "linear-gradient(180deg, rgba(255, 239, 194, 0.28) 0%, rgba(255, 255, 255, 0.51) 68.23%)",
        }}
        mt="10px"
        mb="10px"
      >
        <Box>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography style={styles.cardHeading}>Additional Info</Typography>
            {
              // hasPermission(PERMISSIONS.UPDATE_MEMBER) ||
              // hasPermission(PERMISSIONS.UPDATE_MEMBER_DOB) ||
              hasPermission(PERMISSIONS.UPDATE_FRIEND) ? (
                <Box style={{ cursor: "pointer" }}>
                  <NewEdit onClick={onEditClick} />
                </Box>
              ) : null
            }
          </Box>

          <ProfileRow lebel="Introducer's Name" value={introducerName} />
          <ProfileRow
            lebel="Introducer's Number"
            value={introducerMobileNumber}
          />
          <ProfileRow lebel="Introducer's Email" value={introducerEmail} />

          <div style={{ paddingTop: "20px" }} />

          <Typography style={styles.cardHeading}>Division Details</Typography>
          <ProfileRow lebel="Division" value={divisionName} />
          <ProfileRow lebel="Sub Division" value={subDivisionName} />
        </Box>
      </Box>
      {isLoading && <Loader />}
    </Box>
  );
}
